import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const RecipientsListConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "recipientsList" */
      '../../../components/MoneyManagement/RecipientsList'
    ),
  releaseState: 'internal',
  enabledKey: 'internal',
  teamOwner: 'platform-surfaces',
  sentryTeam: 'platform_surfaces_embedded',
  description: 'Displays the list of V2 recipients for a connected account',
  friendlyName: 'Recipients list',
  enableV2APIToken: true,
};
